import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
} from '@mui/material'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { FormContext } from '../Contexts'
import { FormHandleSubmit, GetSchemaValidation } from '../types'

import { HobbiesValidationSchema } from './ValidationSchemas'
import { hobbies } from '../../../data'

export const HobbiesStep = ({
  id,
  data,
  setActiveForm,
}: {
  id: string
  data?: GetSchemaValidation<typeof HobbiesValidationSchema>
  setActiveForm: (handleSubmit: () => FormHandleSubmit<GetSchemaValidation<typeof HobbiesValidationSchema>>) => void
}) => {
  const { control, handleSubmit, register, setValue, watch, formState, getValues } = useForm({
    resolver: yupResolver(HobbiesValidationSchema),
    defaultValues: data,
  })
  const selectedHobbies = watch('hobbies') || []

  useEffect(() => {
    setActiveForm(() => ({ formId: id, getData: getValues, submit: handleSubmit }))
  }, [getValues, handleSubmit, id, setActiveForm])

  return (
    <FormContext.Provider value={{ control, handleSubmit, register, setValue, watch, formState }}>
      <Grid container spacing={2} rowSpacing={2}>
        <Grid item xs={12} textAlign="left">
          <FormControl component="fieldset">
            <FormGroup row>
              {hobbies.map((hobbie) => (
                <FormControlLabel
                  key={`hobbie-${hobbie}`}
                  value={hobbie}
                  control={<Checkbox />}
                  label={hobbie}
                  checked={selectedHobbies?.includes?.(hobbie)}
                  {...register('hobbies')}
                />
              ))}
            </FormGroup>
          </FormControl>
        </Grid>
      </Grid>
    </FormContext.Provider>
  )
}
